<template>
    <Paper class='applianceCoefficient'>
        <m-panel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @amend-btn="amendBtn"
            @check-btn="checkBtn"
            searchId="bms_appliance_coefficient_query">
            <!-- 按钮区-->
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
                        <el-button icon='el-icon-refresh' size="mini" @click="onRefresh" :loading="loading"></el-button>
                    </el-tooltip>
                </div>
            </div>
        </m-panel>
            <preview-tab-dialog
            :tabData="tabData"
            :openConfigTabDialog="openConfigTabDialog"
            @closeDialog="closeConfigTabDialog">
        </preview-tab-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import mPanel from '@/components/otpPanel';
import config from './config.json';
import lsrmapi from '../../../api/contract/contractSigning';
import previewTabDialog from '../../../components/dialog/previewTabDialog';
import { mapState } from 'vuex';

export default {
    name: 'contractSigning',
    data() {
        return {
            config: config,
            totalData: [],
            pageTotal: 100,
            editState: false,
            selectState: false,
            selectedRows: [],
            dataObj: {},
            loading: false,
            page: {
                pageSize: config.page.pageSize,
                pageNo: config.page.pageNo,
                contractStatuses: ['30', '40', '50', '60', '80'],
                noContractTypes: ['3']
            },
            searchQuery: {},
            pageID: 'lsrm_contract_signing_241205',
            tabData: [],
            RwCarVisiable: false,
            labelPosition: 'right',
            cellShaow: true,
            openConfigTabDialog: false

        };
    },
    computed: {
        ...mapState({ supplier: state => state.supplier })
    },
    methods: {
        onRefresh() {
            this.loadData('refresh');
        },
        selectChange(data) {
            if (data.length > 0) {
                this.selectState = true;
                this.selectedRows = data;
            } else {
                this.selectState = false;
                this.selectedRows = [];
            }
        },
        searchChange(data) {
            this.page.pageNo = 1;
            this.searchQuery = data;
            this.loadData();
        },
        pageChange(data) {
            this.page.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            config.page.pageSize = this.page.pageSize = data;
            this.loadData();
        },
        closeConfigTabDialog(data) {
            this.openConfigTabDialog = data;
        },
        amendBtn(data) {
            var params = {
                fileType: '3',
                contractCodeLike: data.contractCode

            };
            lsrmapi.getFiles(params).then(res => {
                this.loading = false;
                const dataList = res.data.list;
                this.tabData = [];
                dataList.map(item => {
                    if (item.id) {
                        this.tabData.push(item);
                    }
                });
                for (let i = 0; i < this.tabData.length; i++) {
                    this.tabData[i].contractStatus = String(this.tabData[i].contractStatus);
                }
            }).catch(res => {
                this.loading = false;
            });
            this.openConfigTabDialog = true;
        },
        checkBtn(data) {
            lsrmapi.getAuthorizationUrl().then(res => {
                if (res && res.code === '0') {
                    window.open(res.data);
                }
            });
        },
        setContractCode (params) {
            const contractCode = this.$route.query.contractCode;
            if (contractCode !== undefined) {
                params.contractCode = contractCode;
                params.contractStatus = '';
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.searchData.contractStatus = '';
                    this.$refs.tablePage.$refs.searchList.searchData.contractCode = contractCode;
                });
            }
        },
        setContractStatus (params) {
            if (this.$route.query.contractStatus !== undefined) {
                const contractStatus = this.$route.query.contractStatus;
                params.contractStatus = contractStatus;
                if (this.$store.state.supplier) {
                    // LSP
                    params.contractCode = '';
                    this.$nextTick(() => {
                        this.$refs.tablePage.$refs.searchList.searchData.contractStatus = contractStatus;
                        this.$refs.tablePage.$refs.searchList.searchData.contractCode = '';
                    });
                }
            }
        },
        loadData(loadParams) {
            this.loading = true;
            var params = {
                ...this.page,
                ...this.searchQuery,
                suppliersCode: this.supplier === undefined ? '' : this.supplier.supplierCode
            };
            if (this.searchQuery.contractStatus === undefined) {
                this.setContractStatus(params);
            } else if (loadParams === 'refresh' && this.searchQuery.contractStatus === '') {
                this.setContractStatus(params);
            } else if (loadParams === 'activated' && this.searchQuery.contractStatus === '') {
                this.setContractStatus(params);
            }
            if (this.$store.state.supplier) {
                // LSP
                if (this.searchQuery.contractCode === undefined) {
                    this.setContractCode(params);
                } else if (loadParams === 'refresh' && this.searchQuery.contractCode === '') {
                    this.setContractCode(params);
                } else if (loadParams === 'activated' && this.searchQuery.contractCode === '') {
                    this.setContractCode(params);
                }
            }
            lsrmapi.get(params).then(res => {
                this.pageTotal = res.data.totalCount;
                this.totalData = res.data.list;
                var setHiddenEventMap = new Map();

                setHiddenEventMap
                    .set('0', this.hiddenEventType = [ 'check' ]);
                this.totalData.forEach((subItem, subIndex) => {
                    if (subItem.stampMode !== '0') {
                        subItem.stampMode = subItem.contractStatus !== '30' ? '0' : subItem.stampMode;
                    }
                    subItem.hiddenEvent = this.hiddenEventType = setHiddenEventMap.get(subItem.stampMode);
                });
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        }
    },
    activated() {
        if (this.$store.state.supplier) {
            // LSP
            if (this.$route.query.contractCode !== undefined) {
                this.loadData('activated');
            }
            if (this.$route.query.contractStatus !== undefined) {
                this.loadData('activated');
            }
        }
    },
    created() {
        this.loadData();
    },
    components: { Paper, mPanel, previewTabDialog }
};
</script>
<!-- 样式区 -->
<style lang='less'>
    .applianceCoefficient {
        #advanced-search{
            padding-bottom: 0;
        }
    }
</style>
